import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Define the base URL for the API
// const BASE_URL = "http://18.233.85.48:8080/api/";

export const fetchUserwallet = createAsyncThunk(
  "wallets/fetchUserwallet",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/wallets`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      // console.log("response", response.data);
      return response.data; // Return the full response data object
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching userwallet"
      );
    }
  }
);

const userwalletSlice = createSlice({
  name: "userwallet",
  initialState: {
    userwallet: [], // Store the userwallet here
    loading: false,
    error: null,
    wallet: false,
  },
  reducers: {
    setWallet: (state,action) => {
      state.wallet = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Fetch userwallet cases
    builder
      .addCase(fetchUserwallet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserwallet.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.userwallet = action.payload; // Directly assign the userwallet data
        }
      })
      .addCase(fetchUserwallet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch userwallet.";
      });
  },
});
export const { setWallet } = userwalletSlice.actions;
export default userwalletSlice.reducer;
